module.exports = __webpack_public_path__ + "static/media/400105_01.d22dbfcf.png";